





















































































































































































import { Component, Vue } from "vue-property-decorator";
@Component
export default class Container extends Vue {
  gotoIndex(): void {
    if (this.$route.path !== "/") {
      (this.$refs.menu as any).activeIndex = "/";
      this.$router.push("/");
    }
  }
}
